import { Model, Factory, hasMany, trait } from 'miragejs'
import type { ModelDefinition } from 'miragejs/-types'
import { randPhrase } from '@ngneat/falso'

import type { SchemaAttributes } from '../types.js'
import type { MockServer } from './server.js'

export type ComplaintTypeGroupData = SchemaAttributes<'ComplaintTypeGroup'>

export const model = (Model as ModelDefinition<ComplaintTypeGroupData>).extend({
  complaintTypes: hasMany('complaintType'),
})

export const factory = Factory.extend<ComplaintTypeGroupData>({
  name() {
    return randPhrase({ maxCharCount: 40 })
  },
  withComplaintType: trait({
    afterCreate(complaintTypeGroup, server) {
      const complaintTypes = [
        server.create('complaintType'),
        server.create('complaintType'),
      ]
      complaintTypeGroup.update({ complaintTypes })
    },
  }),
})

export function routes(server: MockServer) {
  server.resource('complaintTypeGroup', { path: '/complaint_type_groups' })

  server.get('/complaint_type_groups', function (schema) {
    return schema.all('complaintTypeGroup')
  })
}

export function seeds(server: MockServer) {
  return server.lazySeedingManager?.seedBasic('ComplaintType')
}
